<template>
  <div class="body container">
    <!--导航-->
    <div class="nav clearfix">
      <a
        :class="{'active':column.id == columnid}"
        href="#"
        v-for="column in brotherColumnData"
        :key="column.id"
        @click="changeColumn(column.id, column.fix_column_name)"
      >{{column.title}}</a>
    </div>

    <!--筛选-->
    <div class="selectWrap">
      <h4 class="tip">筛选</h4>
      <div class="selectBox">
        <div class="common">
          <span class="text">类型:</span>
          <div class="common-box">
            <a :class="teacherActive" @click="identityChange(1)" href="JavaScript:;">老师</a>
            <a :class="studentActive" @click="identityChange(2)" href="JavaScript:;">学生</a>
          </div>
        </div>
        <div class="common">
          <span class="text">年级:</span>
          <div class="common-box">
            <a href="javascrpt:;" @click="search_grade(0)" :class="grade == 0 ? 'active' : '' ">全部</a>
            <a
              href="javascrpt:;"
              @click="search_grade(item.gradeid)"
              v-for="item in gradeData"
              :key="item.gradeid"
              :class="grade==item.gradeid ? 'active' : '' "
            >{{item.gradename}}</a>
          </div>
        </div>

        <div class="common" v-if="isTeacher">
          <span class="text">学科:</span>
          <div class="common-box">
            <a @click="search_subject(0)" :class="subject== 0 ? 'active' : '' ">全部</a>
            <a
              @click="search_subject(item.id)"
              v-for="item in subjectData"
              :key="item.id"
              :class="subject==item.id ? 'active' : '' "
            >{{item.name}}</a>
          </div>
        </div>
      </div>
    </div>
    <!--校园视窗-->
    <div class="content wrapper windowsBox">
      <div class="sortBox clearfix">
        <div class="sort fl">
          <a href="javascript:;">默认排序</a>
        </div>
        <div class="searchBox fr">
          <span class="des">共{{this.count}}条结果</span>
          <div>
            <el-input
              v-model="keyword "
              placeholder="用户名，账号搜索"
              class="handle-input mr10 keyword"
              @keyup.enter.native="search"
            ></el-input>

            <a class="searchBtn" @click="search"></a>
          </div>
        </div>
      </div>
      <div class="zone clearfix">
        <div
          class="zone-item"
          style="width:276px;"
          v-for="item in teacherData"
          :key="item.userid"
          @click="toSpace(item)"
        >
          <a target="_blank" class="img" href="JavaScript:;">
            <img :src="item.face" :onerror="errorImg" />
          </a>
          <div class="info-wrap">
            <a target="_blank" class="name" href="JavaScript:;">
              <em style="font-size: 13px;">{{item.username}}</em>
              <span>{{isTeacher == true ? "教师" : "学生"}}</span>
            </a>
            <p class="area">
              <i :class="item.sex == 1 ? 'male' : 'female'"></i>
              <span>{{item.city_name}}</span>
            </p>
            <p class="info">
              <span>{{item.section}}</span>
              <span>{{item.subject}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="noData" v-if="nodata">
        <img src="../../assets/img/no_data.png" />
        <p>暂无数据，去别的地方看看吧~</p>
      </div>
      <div class="btnGroup">
        <!-- 分页 -->
        <div class="btnGroup">
          <div class="pagination">
            <el-pagination
              background
              hide-on-single-page
              @current-change="PageChange"
              layout="prev, pager, next"
              :total="count"
              :current-page="page"
              :page-size="pageSize"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <div class="getHeight"></div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
export default {
  name: "school_space_tch_stu",
  data() {
    return {
      errorImg: 'this.src="' + require("../../assets/img/damage.png") + '"', // 图片损坏默认图
      columnid: this.$route.query.id, // 栏目id
      page: 1,
      pageSize: 16,
      count: 0,
      grade: 0,
      subject: 0,
      keyword: "",
      teacherData: [], // 教师列表数据
      gradeData: [], // 年级列表数据
      subjectData: [], // 学科列表数据
      brotherColumnData: [], // 二级导航数据
      teacherActive: "active",
      studentActive: "",
      nodata: false,
      isTeacher: true // 是否是老师
    };
  },

  components: {},

  computed: {
     globalVaranthasInited(){
         return globalApi.gWebsiteSessionInfo.hasInited;
     }
  },
  watch: {
      globalVaranthasInited: function(){        
        
        this.init();
      },
  },
  created() {
   
  },

  methods: {
    init(){
          this.getGrade();
        this.getSubject();
        this.SearchTeacher();
        this.getBrotherColumn();
      },
    // 教师分页导航
    PageChange(val) {
      this.page = val;
      this.isTeacher ? this.SearchTeacher() : this.SearchStudent();
    },

    // 获取二级导航
    async getBrotherColumn() {
      let data = {
        s: "WebSchoolSpace.Column.GetBrotherColumn",
        columnid: this.columnid,
        weblevel: 1,
        incdisabled: 1
      };

      let res = await globalApi.post( data);
      this.brotherColumnData = res.data.data;
    },

    // 获取年级接口
    async getGrade() {
      const data = {
        s: "WebSchoolSpace.Common.getGrade"
      };
      const response = await globalApi.post( data);
      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }

      this.gradeData = res;
    },

    // 获取学科接口
    async getSubject() {
      const data = {
        s: "WebSchoolSpace.Common.getSubject",
        gradeid: this.grade
      };

      const response = await globalApi.post( data);
      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }
      res.list.splice(0, 1); // 去除返回的0的"学科"
      this.subjectData = res.list;
    },

    // 关键词搜索
    search() {
      this.page = 1;
      this.isTeacher ? this.SearchTeacher() : this.SearchStudent();
    },
    // 搜索学科
    search_subject(val) {
      this.subject = val;
      this.page = 1;
      this.isTeacher ? this.SearchTeacher() : this.SearchStudent();
    },

    // 搜索年级
    search_grade(val) {
      this.grade = val;
      this.page = 1;
      this.isTeacher ? this.SearchTeacher() : this.SearchStudent();
    },

    // 获取老师列表接口
    async SearchTeacher() {
      document.documentElement.scrollTop = 0;
      const data = {
        s: "WebSchoolSpace.Zone.SearchTeacher",
        page: this.page,
        page_size: this.pagesize,
        grade: this.grade,
        subject: this.subject,
        keyword: this.keyword
      };
      const response = await globalApi.post( data);
      const res = response.data.data;

      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }

      this.teacherData = res.list;
      this.count = res.recordcount;
      this.nodata = this.count ? false : true;
    },

    // 获取学生列表接口
    async SearchStudent() {
      document.documentElement.scrollTop = 0;
      const data = {
        s: "WebSchoolSpace.Zone.SearchStudent",
        page: this.page,
        page_size: this.pagesize,
        grade: this.grade,
        keyword: this.keyword
      };
      const response = await globalApi.post( data);
      const res = response.data.data;

      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }

      this.teacherData = res.list;
      this.count = res.recordcount;
    },

    // 二级导航跳转
    changeColumn(id, address) {
      this.$router.push(
        String(
          address + "?id=" + id + "&schoolid=" + this.$route.query.schoolid
        )
      );
    },

    // 跳转教师/学生空间
    toSpace(item) {
      if (this.isTeacher) {
        globalApi.jumpPath(8, "home", "userid=" + item.userid); // 教师空间
      } else {
        globalApi.jumpPath(7, "home", "userid=" + item.userid); // 学生空间
      }
    },

    // 学生老师切换
    // 1-老师
    // 2-学生
    identityChange(type) {
      this.page = 1;
      this.keyword = "";
      if (type == 1) {
        this.teacherActive = "active";
        this.studentActive = "";
        this.SearchTeacher();
        this.isTeacher = true;
      } else {
        this.teacherActive = "";
        this.studentActive = "active";
        this.SearchStudent();
        this.isTeacher = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/index_body.scss";
</style>
<style lang="scss" scoped>
.zone .zone-item .info-wrap .name em {
  line-height: 24px;
}
.keyword {
  width: 90%;
}
.sortBox {
    width: 1180px;
}
</style>


